// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import atop from '@/views/atop'
import atopsearch from '@/views/atopsearch'
import abottom from '@/views/abottom'

Vue.config.productionTip = false
Vue.use(ElementUI);

// 网页共用的头部component模块
Vue.component('atop',atop)
// 网页共用的搜索区component模块
Vue.component('atopsearch',atopsearch)
// 网页共用的页脚component模块
Vue.component('abottom',abottom)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js